import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';

import UserStore from '../services/UserStore';
import UsersService from '../services/UsersService';

Vue.use(VueRouter);

// Configure router
const router = new VueRouter({
  routes, // short for routes: routes
  
  linkActiveClass: 'active',

  scrollBehavior: (to, from ,savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
});

// Add a router guard to prevent viewing routes that aren't for your user group
router.beforeEach(async (to, from, next) => {
  if(!UserStore.userData || (UserStore.userData && !UserStore.userData.group)) {
    await UserStore.fetchUserData();
  }

  // If we don't have a group, redirect to login
  if(to.name != 'Login' && to.name != 'Activate' && to.name != 'Forgot Password' && to.name != 'Reset Password' && (!UserStore.userData || (UserStore.userData && !UserStore.userData.group))) {
    return next('/auth/login');
  }

  // Root redirects to the correct dashboard
  if(to.path == '/'){
    switch(UserStore.userData.group) {
      case 'admins':
        return next('/admin/dashboard');
        break;

      case 'retailerLead':
        return next('/lead-retailer/dashboard');
        break;

      case 'retailers':
        return next('/retailer/dashboard');
        break;

      case 'charities':
        return next('/charity/dashboard');
        break;

      default:
        return next('/404');
        break;
    }
  }

  
  // If the group is admin, limit access 
  if(UserStore.userData && UserStore.userData.group == 'admins' && (to.path.indexOf('/retailer') === 0 || to.path.indexOf('/charity') === 0 || to.path.indexOf('/lead-retailer') === 0)) {
    return next('/403');
  }
  
  // If the group is retailer, limit access 
  if(UserStore.userData && UserStore.userData.group == 'retailers' && (to.path.indexOf('/admin') === 0 || to.path.indexOf('/charity') === 0 || to.path.indexOf('/lead-retailer') === 0)) {
    return next('/403');
  }
  // If the group is retailer, limit access 
  if(UserStore.userData && UserStore.userData.group == 'retailerLead' && (to.path.indexOf('/admin') === 0 || to.path.indexOf('/charity') === 0 || to.path.indexOf('/retailer') === 0)) {
    return next('/403');
  }

  // If the group is charity, limit access 
  if(UserStore.userData && UserStore.userData.group == 'charities' && (to.path.indexOf('/admin') === 0 || to.path.indexOf('/retailer') === 0 || to.path.indexOf('/lead-retailer') === 0)) {
    return next('/403');
  }

  // All is good, allow route
  return next();
})

export default router;
